<template>
    <div v-if="item!=null">
        <h3 class="ui header">
            <span v-if="item.object[0].hasOwnProperty('name')">
                <span v-if="hasOwnDeepProperty(item, 'src.value')">
                    <span v-if="item.src.value=='copy'">
                        <span v-if="personas.hasOwnProperty('copist')">
                            <router-link :to='{ name: "advancedsearch", query: { search: "\""+personas.copist+"\"" } }'>{{personas.copist}}</router-link>
                        </span>
                        <span style="font-weight:normal; font-style: italic;">(copy after
                            <span v-if="personas.hasOwnProperty('artist')">
                                <router-link :to='{ name: "advancedsearch", query: { search: "\""+personas.artist+"\"" } }' class="copist">{{personas.artist}}</router-link>)<br>
                            </span>
                            <span v-else>)<br></span>
                        </span>
                    </span>
                    <span v-else>
                        <router-link :to='{ name: "advancedsearch", query: { search: "\""+personas.artist+"\"" } }'>{{personas.artist}}</router-link><br>
                    </span>
                </span>
                <span v-else>
                    <router-link :to='{ name: "advancedsearch", query: { search: "\""+personas.artist+"\"" } }'>{{personas.artist}}</router-link><br>
                </span>
            </span>
          <!--  <span v-if="item.hasOwnProperty('caption')">{{item.caption}}</span><span v-if="hasOwnDeepProperty(item,'object_info.origDate')">, {{item.object_info.origDate}}</span>-->
            <span v-if="hasOwnDeepPropertyv2(item,'object[0].caption')">{{item.object[0].caption}}</span>
        </h3>
        <span class="">Inventory item:</span><br>

        <span class="italic">{{item.original_inventory_id}}<span v-if="item.hasOwnProperty('original_inventory_id_letter')">{{item.original_inventory_id_letter}}</span> <span v-html="item.text"></span></span><br><br>
        <span v-if="item.hasOwnProperty('room')">
            <span class="">Room:</span> <span class="italic" style="cursor:pointer" v-on:click="$router.push({ name: 'advancedsearch', query: {room:item.room.id } })">{{item.room.original_description}}</span><br>
            <span v-if="item.hasOwnProperty('place')">
                <span class="">Place:</span> <span class="italic">{{item.place.original_description}}</span><br>
                <!--<span class="">Place:</span> <span class="italic"  style="cursor:pointer" v-on:click="searchName(item.place.original_description)">{{item.place.original_description}}</span><br>-->
            </span>
            <br>
        </span>


        <span v-if="!item.hasOwnProperty('note')"><br></span>
        <span v-if="item.hasOwnProperty('note')">
            <span class="">Note:</span><br>{{item.note}}<br><br><br>
        </span>

        <TheIconClass v-if="item.hasOwnProperty('iconclass_external_id')" v-bind:iconid="item.iconclass_external_id"><br><br></TheIconClass>
        <span v-if="!item.hasOwnProperty('iconclass_external_id')" class="italic">Subject:<br></span>
        <!-- <span class="item" v-for="subject in item.subject" :key="subject">{{subject}}, </span>-->
        <span class="item" v-for="(subject, index) in item.subject" :key="subject">{{subject}}<span v-if="index != item.subject.length - 1">, </span></span>
        <span v-if="item.hasOwnProperty('subject')"><br><br><br></span>
        <span v-if="item.hasOwnProperty('price')" class="italic">Price:<br>{{item.price}}<br><br><br></span>
        <span v-if="item.hasOwnProperty('src') || item.hasOwnProperty('size') ||  item.hasOwnProperty('technique') || item.hasOwnProperty('quality')">
            <span class="">Additional information:</span><br>
            <div class="divTable">
                <div class="divTableBody">
                    <div v-if="item.hasOwnProperty('src')" class="divTableRow">
                        <div class="divTableCell" style="width:15%">Source:</div>
                        <div class="divTableCell" style="width:35%">{{item.src.value}} <span v-if="item.src.hasOwnProperty('cert')" class="italic">(certainty:{{item.src.cert}})</span></div>
                        <div class="divTableCell"><span v-if="item.src.hasOwnProperty('indication')" class="italic">{{item.src.indication.toString()}}</span></div>
                    </div>
                    <div v-if="item.hasOwnProperty('size')" class="divTableRow">
                        <div class="divTableCell" style="width:15%">Size:</div>
                        <div class="divTableCell" style="width:35%">{{item.size.value}}</div>
                        <div class="divTableCell"><span v-if="item.size.hasOwnProperty('indication')" class="italic">{{item.size.indication.toString()}}</span></div>
                    </div>
                    <div v-if="item.hasOwnProperty('technique')" class="divTableRow">
                        <div class="divTableCell" style="width:15%">Material:</div>
                        <div class="divTableCell" style="width:35%">{{item.technique.value}}</div>
                        <div class="divTableCell"><span v-if="item.technique.hasOwnProperty('indication')" class="italic">{{item.technique.indication.toString()}}</span></div>
                    </div>
                    <div v-if="item.hasOwnProperty('quality')" class="divTableRow">
                        <div class="divTableCell" style="width:15%">Quality:</div>
                        <div class="divTableCell" style="width:35%">{{item.quality.value}}</div>
                        <div class="divTableCell"><span v-if="item.quality.hasOwnProperty('indication')" class="italic">{{item.quality.indication.toString()}}</span></div>
                    </div>
                </div>
            </div><br><br><br>
        </span>


    </div>

</template>

<script>
    import TheIconClass from './TheIconClass.vue'
    export default {
        props: ['item'],
        data() {
            return {
                //  item: null
                item_with_overstrike: "",
                person: "",
                personas: {}
            }
        },

        methods: {
            searchName: function(name) {
                this.$router.push({ name: 'search', query: { query: '"' + name + '"' } })
            },
            personName: function() {

                var ret = "";
                var role = "artist"
                for (var i in this.item.object[0].name) {
                    if (this.item.object[0].name[i].hasOwnProperty('role')) {
                        role = this.item.object[0].name[i].role;
                    }
                    if (this.item.object[0].name[i].hasOwnProperty('getty_data')) {
                        this.personas[role] = this.item.object[0].name[i].getty_data.display_name;
                    }
                    else {
                        this.personas[role] = this.item.object[0].name[i].value;
                    }
                }

            },
            hasOwnDeepProperty: function(obj, path) {
                var arr;
                for (var i = 0, path = path.split('.'), len = path.length; i < len; i++) {
                    arr = path[i].match(/(.+)\[(\d+)\]/mi);
                    if (arr != null) {
                        if (arr.length == 3) {
                            if (obj[arr[1]]) obj = obj[arr[1]][arr[2]];
                            else return false;
                        }
                    }
                    else obj = obj[path[i]];
                    if (!obj) return false;
                };
                return true;
            },

            hasOwnDeepPropertyv2: function(obj, path) {
                path = path.split('.');
                for (var i in path) {
                    if (path[i].match(/\[\d+\]/mi) == null) {
                        if (obj.hasOwnProperty(path[i])) {
                            obj = obj[path[i]];
                        }
                        else {
                            return false
                        }
                    }
                    else {
                        var matchArr = path[i].match(/\[(\d+)\]/mi);
                        obj = obj[path[i].replace(/\[\d+\]/mi, '')];
                        if (obj != undefined) {
                            obj = obj[matchArr[1]]
                        }
                        else {
                            return false
                        }
                    }
                }
                return true
            },
        },

        mounted() {
            /*   if (this.item.hasOwnProperty('overstrike')) {
                   var rgx = new RegExp(this.item.overstrike, "i");
                   this.item.text = this.item.text.replace(rgx, function(str) {
                       return "<span style='text-decoration: line-through;'>" + str + "</span>";
                   });
               }*/

            if (this.item.hasOwnProperty('overstrike')) {
                var rgx = new RegExp(this.item.overstrike, "i");
                this.item.text = this.item.text.replace(rgx, function(str) {
                    return "<span style='text-decoration: line-through;'>" + str + "</span>";
                });
            }
            if (this.item.inventory.name == '1610_19_Vienna') {
                this.item.text = this.item.text.replace(this.item.title, '<b>' + this.item.title + '</b>');
                /*var rgx = new RegExp(this.item.title, "i");
                this.item.text = this.item.text.replace(rgx, function(str) {
                    return "<b>" + str + "</b>";
                });*/
            }

        },
        created() {
            this.personName();
        },

        components: {
            TheIconClass,
        },
    }
</script>

<style scoped>
    .italic {
        font-style: italic;
    }


    .divTable {
        display: table;
        width: 100%;
    }

    .divTableRow {
        display: table-row;

    }

    .divTableHeading {
        background-color: #EEE;
        display: table-header-group;
    }

    .divTableCell,
    .divTableHead {

        display: table-cell;
        padding: 10px 0px 10px 0px;
        border-bottom: 1px solid #dededf;
    }

    .divTableHeading {
        background-color: #EEE;
        display: table-header-group;
        font-weight: bold;
    }

    .divTableFoot {
        background-color: #EEE;
        display: table-footer-group;
        font-weight: normal;
    }

    .divTableBody {
        display: table-row-group;
    }

    .copist {
        color: #595959;
    }

    .copist:hover {
        color: #2d5386;
    }
</style>



// WEBPACK FOOTER //
// src/components/TheData.vue